import { render, staticRenderFns } from "./StadiumChatRooms.vue?vue&type=template&id=25c25c00&"
import script from "./StadiumChatRooms.vue?vue&type=script&lang=js&"
export * from "./StadiumChatRooms.vue?vue&type=script&lang=js&"
import style0 from "./StadiumChatRooms.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports